var questions = [
  { "id": 1, "indicator": ["i11","i12","i13","i19","i45","i311","i312","i313","i315","firstlog"] },
  { "id": 2, "indicator": ["i15","i16",2]},
  { "id": 3, "indicator": ["i14","i25","i411","i412","i413",3]},
  { "id": 4, "indicator": ["i42","i43","i44",4]},
  { "id": 5, "indicator": ["i17","i18",5]},
  { "id": 6, "indicator": ["i21","i24","i321","i322","i323","i325","finished"]}
  ]

export default questions;



// WEBPACK FOOTER //
// ./src/data/questions.js